<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getList" :filter="filter" :min-search-char-limit="0"
    :externaledit="externaledit" :clearable="clearable" :multiple="multiple" :returnobject="returnobject"
    :disabled="disabled" :loading="loading" valuekey="code" textkey="label" :label="label ? label : $t('language')"
    :placeholder="placeholder ? placeholder : $t('language')" @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <template v-slot:prepend-outer>
      <v-icon size="18">mdi-translate</v-icon>
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import languages from "@/api/Constants/languages";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "LanguageSelect",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      languages: languages,
    };
  },

  methods: {
    async getList(filtersAndPagination) {
      var list = Object.assign([], this.languages);
      var query = filtersAndPagination.SearchWord;
      if (query) {
        list = list.filter((item) => (item.Name.toUpperCase()).includes(query.toUpperCase()));
      }
      //console.log(query, list.length);
      return list;
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>